import { DotLegalSelect } from "@dotlegal/dotlegal-ui-components";
import { useTranslation } from "@localization/useTranslation";
import { approvedLegalEntityOptionId, getLegalEntityApprovedOptions, notApprovedLegalEntityOptionId } from "./legalEntityFieldOptions.ts";

export interface LegalEntityApprovedFieldProps {
    isApproved: boolean;
    onChange: (isApproved: boolean) => void;
    disabled?: boolean;
    isLoading?: boolean;
    errorText?: string;
}

// Approval is a yes/no the user always has to answer, so the select is never clearable: an empty value would
// read as "not decided", which the entity has no way to store.
function LegalEntityApprovedField(props: LegalEntityApprovedFieldProps) {
    const { translateString } = useTranslation();

    return (
        <DotLegalSelect
            options={getLegalEntityApprovedOptions(translateString)}
            selectedItem={props.isApproved ? approvedLegalEntityOptionId : notApprovedLegalEntityOptionId}
            onChange={(approved) => props.onChange(approved === approvedLegalEntityOptionId)}
            placeholder={translateString("approved")}
            label={translateString("approved")}
            noOptionsLabel={translateString("noOptions")}
            disabled={props.disabled}
            errorText={props.errorText}
            isLoading={props.isLoading}
            disableClearable
        />
    );
}

export default LegalEntityApprovedField;
